import React from "react";
import type { PostSummary } from "@/types";
import { useRouter } from "@/router/Router";
import { mediaUrl } from "@/lib/api";

export function PostCard({ post, compact }: { post: PostSummary; compact?: boolean }) {
  const { navigate } = useRouter();
  const cover = mediaUrl(post.coverImage);
  return (
    <button className={`card post-card ${compact ? "post-card--compact" : ""}`} onClick={() => navigate({ name: "post", slug: post.slug })}>
      {cover ? <img src={cover} alt="" className="post-card__cover" loading="lazy" /> : <div className="post-card__cover post-card__cover--empty" aria-hidden="true" />}
      <div className="post-card__body">
        <div className="post-card__title">{post.title}</div>
        {post.excerpt && <div className="post-card__excerpt">{post.excerpt}</div>}
      </div>
    </button>
  );
}
